import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Box,
  Stack,
  TextField,
  Paper,
  LinearProgress,
  Typography,
} from "@mui/material";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import { useFormik, FormikProvider, Form } from "formik";
import * as Yup from "yup";
import useResponsive from "../../../Hooks/useResponsive";
import dayjs from "dayjs";
import {
  getEmployeesDirectUnder,
  getOgaLists,
  getOGMDashboardCounts,
} from "../../../redux/features/OgdDashboard";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import GlobalMultiSelect from "../../../components/mui/GlobalMultiSelect";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { sogoAssessmentTableHeader } from "../../../components/datagrid/OgdDashboard/sogoAssessmentTableHeader";
import TotalNoOfReports from "../ogmDashboard/TotalNoOfReports";
import GlobalSelectFieldWithoutFormikNew from "../../../components/mui/GlobalSelectFieldWithoutFormikNew";
import ProgressBar from "../../../components/mui/ProgressBar";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import AddOrUpdateTarget from "../../ogd/myworkspace/TargetOrSlots/AddOrUpdateTarget";
const selectionData = [
  { id: 1, value: "None" },
  { id: 2, value: "Assessment Based" },
];
const SogoWiseReport = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;
  const sogoIdParam = searchParams.get("sogoId");
  const fromDateParam = searchParams.get("fromDate");
  const toDateParam = searchParams.get("toDate");
  const dateFilterCriteriaParams = searchParams.get("filterCriteria");
  const [fromDate, setFromDate] = useState(
    fromDateParam || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    toDateParam || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");
  const [selectedOga, setSelectedOga] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate("");
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, sogoList, ogaList, resData } = useSelector(
    (store) => store.ogdDashboard
  );
  const { data, meta } = resData;
  const [selectedDateCriteria, setSelectedDateCriteria] = useState(
    dateFilterCriteriaParams
      ? selectionData.find((data) => data.id == dateFilterCriteriaParams)
      :  { id: 1, value: "None" }
  );
  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);

  useEffect(() => {
    dispatch(getEmployeesDirectUnder()); //GETTING THE SOGOS LIST UNDER THE LOGGINED OGM HEAD FOR OGM HEAD LOGIN THEN FILTER PURPOSE
  }, []);

  const initialValues = {
    //SOGO ID SET WITH IF URL PARAMS GIVE  A  SOGO ID THEN IT WILL REPLACE THE SOGO ID ,OTHER WISE THE THAT DASHBOARD WILL APPEAR THROUGH SOGO DASHBOARD THEN SOGO ID REPLACE WIHT LOGINED SOGO USER ID
    sogoId: sogoIdParam
      ? sogoIdParam
      : // : userProfile.roleID == 90
        // ? userProfile.userId
        "",
  };
  const schema = Yup.object({
    // sogoId: Yup.number().required('SOGO Required'),
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(values);
    },
  });
  const handleSogoChange = (e, option) => {
    formik.setFieldValue("sogoId", option?.userID);
  };

  useEffect(() => {
    if (formik.values.sogoId) {
      dispatch(getOgaLists(formik.values.sogoId));
    }
  }, [formik.values.sogoId]);

  const dispatchParams = {
    fromDate: dayjs(fromDate).format("YYYY-MM-DD"),
    toDate: dayjs(toDate).format("YYYY-MM-DD"),
    ogaIds: selectedOga,
    sogoId: formik.values.sogoId,
    paginationData,
    paginationData: paginationData,
    selectedDateCriteria,
  };
  useEffect(() => {
    if (paginationData.pageNum && paginationData.gridSize) {
      dispatch(getOGMDashboardCounts(dispatchParams));
    }
  }, [
    fromDate,
    toDate,
    formik.values.sogoId,
    selectedOga,
    gridSize,
    pageNum,
    search,
    selectedDateCriteria,
  ]);

  const UnconfirmedNavigation = () => {
    // console.log("formik.values.sogoId", formik.values.sogoId);
    navigate(
      `/my-workspace/assessment-dashboard?fromDate=${dayjs(fromDate).format(
        "YYYY-MM-DD"
      )}&toDate=${dayjs(toDate).format("YYYY-MM-DD")}`
    );
  };

  return (
    <GlobalWrapper title={"Assessment Reports"}>
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <Box>
            <Stack gap={1} direction={direction} mb={1}>
              <Box sx={{ flex: 1.5 }}>
                <FromAndToDatePicker
                  disabled={false}
                  fromDate={fromDate}
                  toDate={toDate}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  fullWidth={true}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <GlobalSelectFieldWithoutFormikNew
                  keys={{ itemId: "id", itemValue: "value" }}
                  data={selectionData}
                  label={"Filter Criteria"}
                  fullWidth={true}
                  selectedDetails={selectedDateCriteria}
                  setChange={setSelectedDateCriteria}
                />
              </Box>

              {sogoIdParam && (
                <Box sx={{ flex: 1 }}>
                  <Autocomplete
                    fullWidth
                    name="sogoId"
                    options={sogoList}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      sogoList?.find(
                        (sogo) => sogo?.userID == formik.values.sogoId
                      ) || null
                    }
                    onChange={handleSogoChange}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="SOGO"
                        error={
                          formik.touched.sogoId && Boolean(formik.errors.sogoId)
                        }
                        helperText={
                          formik.touched.sogoId && formik.errors.sogoId
                        }
                      />
                    )}
                  />
                </Box>
              )}

              <Box sx={{ flex: 1 }}>
                <GlobalMultiSelect
                  sx={{ minWidth: "300px" }}
                  disabled={loading}
                  label={"OGA Filter"}
                  fullWidth={mdDown ? true : false}
                  arrayState={selectedOga}
                  arraySetState={setSelectedOga}
                  data={ogaList}
                  keys={{ id: "userID", value: "name" }}
                />
              </Box>
            </Stack>

            {true && (
              <TotalNoOfReports
                assessmentTaken={data?.headData?.[0]?.totalAssessmentCount}
                reportGenerated={data?.headData?.[0]?.totalReportCount}
                totalCourseEnrollmentCount={
                  data?.headData?.[0]?.totalCourseEnrollmentCount
                }
                totalAdmissionCount={data?.headData?.[0]?.totalAdmissionCount}
                totalArpu={data?.headData?.[0]?.totalArpu}
                totalAcr={data?.headData?.[0]?.totalAcr}
                totalTar={data?.headData?.[0]?.totalTar}
                totalSfr={data?.headData?.[0]?.totalSfr}
                top={data?.headData?.[0]?.topUserNames}
                saleAmount={data?.headData?.[0]?.totalTotalFees}
                revenue={data?.headData?.[0]?.totalRevenue}
                admissionNotConfirmed={
                  data?.headData?.[0]?.totalUnenrolledCount
                }
                navigateFunction={UnconfirmedNavigation}
              />
            )}

            <Box
              mt={1}
              p={1}
              sx={{
                background:
                  "linear-gradient(135deg,rgba(0, 139, 208, 0.79),rgba(160, 37, 194, 0.74))",
                borderRadius: 3,
              }}
            >
              <Stack gap={1} direction={direction}>
                <ProgressBar
                  achieved={{
                    name: "Achieved",
                    value: data?.headData?.[0]?.achievedTarget,
                  }}
                  target={{
                    name: "Target",
                    value: data?.headData?.[0]?.target,
                  }}
                />
                <ProgressBar
                  achieved={{
                    name: "Slot",
                    value: data?.headData?.[0]?.achievedSlot,
                  }}
                  target={{
                    name: "Slot Goal",
                    value: data?.headData?.[0]?.slot,
                  }}
                />
              </Stack>
            </Box>

            <Box mt={1}>
              <Paper elevation={1}>
                <GlobalDatagrid
                  tableHead={sogoAssessmentTableHeader(
                    navigate,
                    fromDate,
                    toDate,
                    selectedDateCriteria
                  )}
                  rows={data?.userData}
                  meta={meta?.totalRecords}
                  rowUniqueId="userId"
                  loading={loading}
                  rowClick={true}
                  actionComponent={
                    <>
                      <ActionDetails val={rowData?.userName} />
                      <GlobalAnchorList
                        label={"Add Or Update\u00A0 "}
                        component={
                          <AddOrUpdateTarget
                            rowData={rowData}
                            dispatchParams={dispatchParams}
                          />
                        }
                      />
                    </>
                  }
                />
              </Paper>
            </Box>
          </Box>
        </Form>
      </FormikProvider>
    </GlobalWrapper>
  );
};

export default SogoWiseReport;
